import { createContext } from 'react';
import initialCommercialProfileState from './initialCommercialProfileState';

const CommercialProfileContext = createContext(initialCommercialProfileState);

export default CommercialProfileContext;
